import { Helmet } from "react-helmet-async";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

export default function Faq({ items = [], title = "Domande frequenti", eyebrow = "// FAQ" }) {
  if (!items.length) return null;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((it) => ({
      "@type": "Question",
      name: it.q,
      acceptedAnswer: { "@type": "Answer", text: it.a },
    })),
  };

  return (
    <section data-testid="faq-section" className="py-24 bg-background border-t border-border">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>

      <div className="max-w-[1500px] mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Reveal>
            <p className="font-mono text-xs uppercase tracking-widest text-primary mb-6">{eyebrow}</p>
            <h2 className="font-head font-black text-3xl md:text-4xl tracking-tightest sticky top-28 leading-[0.95]">
              {title}
            </h2>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="w-full border-t border-border">
              {items.map((it, i) => (
                <AccordionItem
                  key={i}
                  value={`faq-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-border"
                >
                  <AccordionTrigger className="py-6 font-head font-bold text-lg md:text-xl tracking-tight hover:no-underline">
                    {it.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 text-base text-muted-foreground leading-relaxed max-w-3xl">
                    {it.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
